import React, { useState } from 'react';
import { Grid, Typography, Button } from "@mui/material";
import { PageContainer } from "../../survey-tools/ui-components/containers";

export default function ThinkAloudInstructions({ finishInstructions = () => console.log('end instructions') }) {
    const [page, setPage] = useState(1);
    const totalPages = 4;

    const handleNext = () => {
        if (page < totalPages) {
            setPage(page + 1);
        } else {
            finishInstructions(); // Call when the final page is reached
        }
    };

    return (
        <PageContainer>
            <Grid item xs={11} sm={9} md={7} lg={5}>
                {page === 1 && (
                    <Typography gutterBottom sx={{ marginBottom: '1em' }}>
                        The next question will involve recording an audio response. On the next few pages, we will provide you with instructions regarding the task. After that, you will be asked to record your response.
                    </Typography>
                )}
                {page === 2 && (
                    <Typography gutterBottom sx={{ marginBottom: '1em' }}>
                        For 10 minutes, please report whatever you can on your stream of thought. Your report may include (but is not limited to) descriptions of: images, conversations, thoughts, sensations, feelings, memories of past experiences, thought or images of future experiences. Simply say whatever is going through your mind from moment to moment.
                    </Typography>
                )}
                {page === 3 && (
                    <Typography gutterBottom sx={{ marginBottom: '1em' }}>
                        Report your thoughts and feelings as they come to you. Try to talk continuously during the entire time. Don’t worry about grammar or complete sentences. If your thoughts or feelings recur over and over, simply say them over and over.
                    </Typography>
                )}
                {page === 4 && (
                    <Typography gutterBottom sx={{ marginBottom: '1em' }}>
                        Remember that we are interested in your saying any and all thoughts and feelings that come to you no matter how silly or personal you think they may be.
                    </Typography>
                )}
                <Button 
                    onClick={handleNext}
                    variant={'contained'}
                    sx={{ alignSelf: 'end', marginBottom: '1em' }}
                    color={'primary'}>
                    {page < totalPages ? 'Next' : 'Next'}
                </Button>
            </Grid>
        </PageContainer>
    );
}
